import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Card } from '../../components/ui/Card';

const API_BASE = 'https://api.glowytics.com';

// Special brand ID for dummy data
const DUMMY_DATA_BRAND_ID = 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4';

// Generate dummy audiences data
const generateDummyAudiences = () => {
  const audiences = [
    // LOOKALIKE audiences
    { id: '23847563891001', name: 'LAL - Purchasers 1%', subtype: 'LOOKALIKE', approximate_count: 850000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-15', time_updated: '2024-12-20' },
    { id: '23847563891002', name: 'LAL - Purchasers 2%', subtype: 'LOOKALIKE', approximate_count: 1700000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-15', time_updated: '2024-12-20' },
    { id: '23847563891003', name: 'LAL - Purchasers 5%', subtype: 'LOOKALIKE', approximate_count: 4250000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-15', time_updated: '2024-12-20' },
    { id: '23847563891004', name: 'LAL - High Value Customers 1%', subtype: 'LOOKALIKE', approximate_count: 820000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-09-10', time_updated: '2024-12-18' },
    { id: '23847563891005', name: 'LAL - Add to Cart 1%', subtype: 'LOOKALIKE', approximate_count: 890000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-09-20', time_updated: '2024-12-15' },
    { id: '23847563891006', name: 'LAL - Website Visitors 1%', subtype: 'LOOKALIKE', approximate_count: 920000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-10-01', time_updated: '2024-12-22' },
    { id: '23847563891007', name: 'LAL - App Users 2%', subtype: 'LOOKALIKE', approximate_count: 1650000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-10-15', time_updated: '2024-12-20' },
    
    // CUSTOM audiences (Website)
    { id: '23847563892001', name: 'Website - All Visitors 180D', subtype: 'CUSTOM', approximate_count: 2500000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-06-01', time_updated: '2024-12-25' },
    { id: '23847563892002', name: 'Website - Purchasers 30D', subtype: 'CUSTOM', approximate_count: 45000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-06-01', time_updated: '2024-12-25' },
    { id: '23847563892003', name: 'Website - Purchasers 90D', subtype: 'CUSTOM', approximate_count: 125000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-06-01', time_updated: '2024-12-25' },
    { id: '23847563892004', name: 'Website - Add to Cart 14D', subtype: 'CUSTOM', approximate_count: 85000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-07-15', time_updated: '2024-12-25' },
    { id: '23847563892005', name: 'Website - Product Viewers 7D', subtype: 'CUSTOM', approximate_count: 320000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-07-15', time_updated: '2024-12-25' },
    { id: '23847563892006', name: 'Website - Cart Abandoners', subtype: 'CUSTOM', approximate_count: 65000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-01', time_updated: '2024-12-25' },
    { id: '23847563892007', name: 'Website - Category: Kadın Giyim', subtype: 'CUSTOM', approximate_count: 180000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-15', time_updated: '2024-12-24' },
    { id: '23847563892008', name: 'Website - Category: Erkek Giyim', subtype: 'CUSTOM', approximate_count: 145000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-15', time_updated: '2024-12-24' },
    
    // CUSTOM audiences (Customer List)
    { id: '23847563893001', name: 'CRM - All Customers', subtype: 'CUSTOM', approximate_count: 890000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-05-01', time_updated: '2024-12-20' },
    { id: '23847563893002', name: 'CRM - VIP Customers', subtype: 'CUSTOM', approximate_count: 12000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-05-01', time_updated: '2024-12-20' },
    { id: '23847563893003', name: 'CRM - Newsletter Subscribers', subtype: 'CUSTOM', approximate_count: 450000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-06-15', time_updated: '2024-12-18' },
    { id: '23847563893004', name: 'CRM - Churned Customers 90D', subtype: 'CUSTOM', approximate_count: 78000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-07-01', time_updated: '2024-12-22' },
    
    // CUSTOM audiences (App Activity)
    { id: '23847563894001', name: 'App - Active Users 30D', subtype: 'CUSTOM', approximate_count: 380000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-09-01', time_updated: '2024-12-25' },
    { id: '23847563894002', name: 'App - In-App Purchasers', subtype: 'CUSTOM', approximate_count: 52000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-09-01', time_updated: '2024-12-25' },
    { id: '23847563894003', name: 'App - Installers 90D', subtype: 'CUSTOM', approximate_count: 145000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-09-15', time_updated: '2024-12-24' },
    
    // SAVED audiences (Interest-based)
    { id: '23847563895001', name: 'INT - Fashion & Apparel TR', subtype: 'SAVED', approximate_count: 12500000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-04-01', time_updated: '2024-11-15' },
    { id: '23847563895002', name: 'INT - Online Shoppers TR', subtype: 'SAVED', approximate_count: 18000000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-04-01', time_updated: '2024-11-15' },
    { id: '23847563895003', name: 'INT - Women 25-44 Fashion', subtype: 'SAVED', approximate_count: 6800000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-05-10', time_updated: '2024-11-20' },
    { id: '23847563895004', name: 'INT - Men 18-35 Casual', subtype: 'SAVED', approximate_count: 5200000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-05-10', time_updated: '2024-11-20' },
    { id: '23847563895005', name: 'INT - Parents with Kids', subtype: 'SAVED', approximate_count: 8900000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-06-20', time_updated: '2024-10-30' },
    { id: '23847563895006', name: 'INT - Luxury Fashion Enthusiasts', subtype: 'SAVED', approximate_count: 2100000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-07-15', time_updated: '2024-12-01' },
    
    // VIDEO audiences
    { id: '23847563896001', name: 'Video - 75% Viewers 30D', subtype: 'CUSTOM', approximate_count: 125000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-10-01', time_updated: '2024-12-24' },
    { id: '23847563896002', name: 'Video - 95% Viewers 60D', subtype: 'CUSTOM', approximate_count: 48000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-10-01', time_updated: '2024-12-24' },
    
    // ENGAGEMENT audiences
    { id: '23847563897001', name: 'IG - Profile Engagers 90D', subtype: 'CUSTOM', approximate_count: 520000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-01', time_updated: '2024-12-23' },
    { id: '23847563897002', name: 'FB - Page Engagers 90D', subtype: 'CUSTOM', approximate_count: 380000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-08-01', time_updated: '2024-12-23' },
    { id: '23847563897003', name: 'IG - Ad Engagers 30D', subtype: 'CUSTOM', approximate_count: 245000, delivery_status: 'ready', operation_status: 'Normal', time_created: '2024-09-15', time_updated: '2024-12-25' },
  ];
  
  return audiences;
};

// Generate dummy audience detail
const generateDummyAudienceDetail = (audience) => {
  const baseDetail = {
    id: audience.id,
    name: audience.name,
    approximate_count: audience.approximate_count,
    delivery_status: audience.delivery_status,
    operation_status: audience.operation_status,
    time_created: audience.time_created,
    time_updated: audience.time_updated,
    description: `${audience.name} - Auto-generated audience for targeting`,
  };
  
  if (audience.subtype === 'SAVED') {
    return {
      ...baseDetail,
      kind: 'SAVED',
      targeting_summary: {
        include: {
          interests: ['Fashion', 'Online Shopping', 'Clothing', 'Shoes', 'Accessories'],
          behaviors: ['Engaged Shoppers', 'Online Buyers'],
          industries: [],
          life_events: []
        },
        exclude: {
          interests: [],
          behaviors: []
        },
        locations: {
          countries: ['Turkey'],
          countryGroups: [],
          cities: ['Istanbul', 'Ankara', 'Izmir'],
          regions: []
        },
        demographics: {
          ageMin: 18,
          ageMax: 65,
          genders: ['male', 'female'],
          languages: ['tr', 'en']
        }
      },
      targeting: {
        geo_locations: { countries: ['TR'] },
        age_min: 18,
        age_max: 65,
        flexible_spec: [{ interests: [{ id: '6003107902433', name: 'Fashion' }] }]
      }
    };
  } else if (audience.subtype === 'LOOKALIKE') {
    return {
      ...baseDetail,
      kind: 'CUSTOM',
      lookalike: {
        origin_audience_id: '23847563892002',
        ratio: audience.name.includes('1%') ? 0.01 : audience.name.includes('2%') ? 0.02 : 0.05,
        country: 'TR'
      }
    };
  } else {
    return {
      ...baseDetail,
      kind: 'CUSTOM',
      rule: {
        inclusions: {
          operator: 'or',
          rules: [
            { event_sources: [{ type: 'pixel', id: '123456789' }], retention_seconds: 2592000 }
          ]
        }
      }
    };
  }
};

export default function MetaAudiencesLab() {
  const { selectedBrand } = useAuth();
  const [audiences, setAudiences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [active, setActive] = useState(null); // { id, subtype }
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailError, setDetailError] = useState('');
  const [cache, setCache] = useState(() => ({})); // id -> detail
  const [showRaw, setShowRaw] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  // Create Saved Audience modal state
  const [showCreate, setShowCreate] = useState(false);
  const [caName, setCaName] = useState('');
  const [caInterests, setCaInterests] = useState('');
  const [caCountries, setCaCountries] = useState('TR');
  const [caToken, setCaToken] = useState('');
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState('');
  const [createResult, setCreateResult] = useState(null);
  const [expandedGroups, setExpandedGroups] = useState({});

  const filtered = useMemo(() => {
    if (!search.trim()) return audiences;
    const q = search.toLowerCase();
    return audiences.filter(a =>
      (a.name || '').toLowerCase().includes(q) ||
      (a.subtype || '').toLowerCase().includes(q) ||
      (a.id || '').toLowerCase().includes(q)
    );
  }, [audiences, search]);

  const grouped = useMemo(() => {
    const groups = new Map();
    for (const a of filtered) {
      const k = a.subtype || 'UNKNOWN';
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k).push(a);
    }
    const order = Array.from(groups.keys()).sort((a, b) => a.localeCompare(b));
    return order.map(key => ({ key, items: groups.get(key) }));
  }, [filtered]);

  // Prefetch details for all audiences after load (limited concurrency)
  useEffect(() => {
    const prefetch = async () => {
      if (!selectedBrand?.id || audiences.length === 0) return;
      const maxConcurrent = 6;
      const queue = [...audiences];
      const running = [];
      const makeTask = (item) => async () => {
        try {
          if (cache[item.id]) return;
          const url = new URL(`${API_BASE}/api/meta-ads/audiences/${encodeURIComponent(item.id)}`);
          const kind = (item.subtype || '') === 'SAVED' ? 'SAVED' : 'CUSTOM';
          url.searchParams.set('kind', kind);
          const resp = await fetch(url.toString(), {
            credentials: 'include',
            headers: { 'X-Brand-ID': selectedBrand.id }
          });
          if (!resp.ok) return;
          const data = await resp.json().catch(() => null);
          const d = data?.data || null;
          if (d) {
            setCache(prev => (prev[item.id] ? prev : { ...prev, [item.id]: d }));
          }
        } catch (_) {}
      };
      const pump = async () => {
        while (queue.length > 0) {
          while (running.length < maxConcurrent && queue.length > 0) {
            const item = queue.shift();
            const p = makeTask(item)().finally(() => {
              const idx = running.indexOf(p);
              if (idx >= 0) running.splice(idx, 1);
            });
            running.push(p);
          }
          await Promise.race(running);
        }
        await Promise.allSettled(running);
      };
      pump();
    };
    prefetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBrand?.id, audiences]);

  const openDetail = async (item) => {
    setActive(item);
    setDetailError('');
    if (cache[item.id]) {
      setDetail(cache[item.id]);
      return;
    }
    setDetail(null);
    setDetailLoading(true);
    try {
      const url = new URL(`${API_BASE}/api/meta-ads/audiences/${encodeURIComponent(item.id)}`);
      const kind = (item.subtype || '') === 'SAVED' ? 'SAVED' : 'CUSTOM';
      url.searchParams.set('kind', kind);
      const resp = await fetch(url.toString(), {
        credentials: 'include',
        headers: { 'X-Brand-ID': selectedBrand.id }
      });
      if (!resp.ok) {
        const d = await resp.json().catch(() => ({}));
        throw new Error(d?.error || d?.details || `HTTP ${resp.status}`);
      }
      const data = await resp.json();
      const d = data?.data || null;
      setDetail(d);
      setCache(prev => ({ ...prev, [item.id]: d }));
    } catch (e) {
      setDetailError(e.message || 'Failed to fetch audience detail');
    } finally {
      setDetailLoading(false);
    }
  };

  const closeDetail = () => {
    setActive(null);
    setDetail(null);
    setDetailError('');
    setDetailLoading(false);
    setShowRaw(false);
  };

  useEffect(() => {
    const run = async () => {
      if (!selectedBrand?.id) return;
      setLoading(true);
      setError('');
      setAudiences([]);
      
      // Check if this is the special brand that needs dummy data
      if (selectedBrand.id === DUMMY_DATA_BRAND_ID) {
        console.log('Using dummy audiences data for special brand:', selectedBrand.id);
        const dummyAudiences = generateDummyAudiences();
        setAudiences(dummyAudiences);
        
        // Pre-populate cache with dummy details
        const dummyCache = {};
        dummyAudiences.forEach(audience => {
          dummyCache[audience.id] = generateDummyAudienceDetail(audience);
        });
        setCache(dummyCache);
        
        setTimeout(() => setLoading(false), 500);
        return;
      }
      
      try {
        // Resolve ad account from META_ADS connection
        const connResp = await fetch(`${API_BASE}/api/auth/connections`, {
          credentials: 'include',
          headers: { 'X-Brand-ID': selectedBrand.id }
        });
        if (!connResp.ok) {
          const d = await connResp.json().catch(() => ({}));
          throw new Error(d?.error || d?.details || `HTTP ${connResp.status}`);
        }
        const connData = await connResp.json();
        const connections = Array.isArray(connData) ? connData : (Array.isArray(connData?.connections) ? connData.connections : []);
        const metaAds = connections.find(c => c.platform === 'META_ADS' && c.status === 'ACTIVE');
        const adAccountId = metaAds?.customerId || null;
        const url = new URL(`${API_BASE}/api/meta-ads/audiences`);
        if (adAccountId) url.searchParams.set('adAccountId', adAccountId);
        const resp = await fetch(url.toString(), {
          credentials: 'include',
          headers: { 'X-Brand-ID': selectedBrand.id }
        });
        if (!resp.ok) {
          const d = await resp.json().catch(() => ({}));
          throw new Error(d?.error || d?.details || `HTTP ${resp.status}`);
        }
        const data = await resp.json();
        setAudiences(Array.isArray(data?.data) ? data.data : []);
      } catch (e) {
        setError(e.message || 'Failed to load audiences');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [selectedBrand?.id, reloadKey]);

  const createSavedAudience = async () => {
    try {
      if (!selectedBrand?.id) return;
      // Resolve ad account id (same flow as listing)
      let adAccountId = null;
      try {
        const connResp = await fetch(`${API_BASE}/api/auth/connections`, {
          credentials: 'include',
          headers: { 'X-Brand-ID': selectedBrand.id }
        });
        const connData = await connResp.json().catch(() => ({}));
        const connections = Array.isArray(connData) ? connData : (Array.isArray(connData?.connections) ? connData.connections : []);
        const metaAds = connections.find(c => c.platform === 'META_ADS' && c.status === 'ACTIVE');
        adAccountId = metaAds?.customerId || null;
      } catch (_) {}
      const name = (caName || '').trim();
      const interests = (caInterests || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      const countries = (caCountries || '')
        .split(',')
        .map(s => s.trim().toUpperCase())
        .filter(Boolean);
      if (!name) { setCreateError('Name required'); return; }
      if (interests.length === 0) { setCreateError('Enter at least one interest'); return; }
      setCreating(true);
      setCreateError('');
      setCreateResult(null);
      const resp = await fetch(`${API_BASE}/api/meta-ads/saved-audiences`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': selectedBrand.id,
          ...(caToken.trim() ? { 'X-Meta-Access-Token': caToken.trim() } : {})
        },
        body: JSON.stringify({ name, interests, countries, adAccountId, ...(caToken.trim() ? { access_token: caToken.trim() } : {}) })
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || !data?.ok) {
        throw new Error(data?.error || data?.details || `HTTP ${resp.status}`);
      }
      setCreateResult(data?.data || { id: 'created' });
      // Refresh list
      setReloadKey(k => k + 1);
    } catch (e) {
      setCreateError(e?.message || 'Failed to create saved audience');
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <Card className="p-5 rounded-2xl shadow-sm">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-3 bg-blue-50 rounded-xl border border-blue-100">
              <img src="/6033716.png" alt="Meta" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">Meta Audiences</h1>
              <p className="text-sm text-gray-500 mt-1">Lists custom audiences for your Meta ad account.</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <input
              className="px-3 py-2 border border-gray-300 rounded-md text-sm"
              placeholder="Search by name, subtype or ID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <span className="px-3 py-1 rounded-xl text-xs bg-gray-100 text-gray-700">
              {loading ? 'Loading…' : `Loaded: ${audiences.length}`}
            </span>
          </div>
        </div>
        {!selectedBrand?.id && <div className="mt-3 text-sm text-red-500">Please select a brand.</div>}
        {error && <div className="mt-3 text-sm text-red-500">{error}</div>}
      </Card>

      <Card className="mt-6 rounded-xl">
        <div className="p-4 border-b">
          <h2 className="font-medium text-gray-800">Audiences</h2>
        </div>
        <div className="p-4">
          {loading ? (
            <div className="text-sm text-gray-500">Loading…</div>
          ) : filtered.length === 0 ? (
            <div className="text-sm text-gray-500">No audiences found.</div>
          ) : (
            <div className="space-y-8">
              {grouped.map(group => (
                <div key={group.key}>
                  <div className="flex items-center justify-between mb-3">
                    <div className="inline-flex items-center gap-2">
                      <span className="text-sm font-semibold text-gray-800">{group.key}</span>
                      <span className="px-2 py-0.5 rounded-full text-[10px] bg-gray-100 text-gray-700">
                        {group.items.length}
                      </span>
                    </div>
                    <button
                      type="button"
                      onClick={() =>
                        setExpandedGroups(prev => ({
                          ...prev,
                          [group.key]: !prev[group.key]
                        }))
                      }
                      className="text-xs px-2 py-1 rounded-full border border-gray-200 text-gray-600 hover:bg-gray-50"
                    >
                      {expandedGroups[group.key] ? 'Hide' : 'Show'}
                    </button>
                  </div>
                  {expandedGroups[group.key] && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {group.items.map(a => (
                      <button
                        key={a.id}
                        type="button"
                        onClick={() => openDetail(a)}
                        className="text-left border border-gray-200 rounded-xl p-3 bg-white hover:shadow-sm transition w-full"
                      >
                        <div className="flex items-start justify-between">
                          <div className="min-w-0">
                            <div className="text-sm font-medium text-gray-900 truncate" title={a.name || ''}>
                              {a.name || '—'}
                            </div>
                            <div className="mt-1 text-[11px] text-gray-500 truncate" title={a.id}>
                              {a.id}
                            </div>
                          </div>
                          <span className="ml-2 px-2 py-0.5 rounded-full text-[10px] bg-indigo-50 text-indigo-700 border border-indigo-200">
                            {a.subtype || '—'}
                          </span>
                        </div>
                        <div className="mt-3 flex items-center justify-between">
                          <div className="text-[11px] text-gray-700">
                            {a.approximate_count != null ? a.approximate_count.toLocaleString() : '—'}
                            <span className="text-gray-400"> users</span>
                          </div>
                          <div className="text-[11px] text-gray-700 truncate max-w-[50%]" title={a.delivery_status || ''}>
                            {a.delivery_status || '—'}
                          </div>
                        </div>
                        <div className="mt-2 text-[11px] text-gray-500 flex items-center justify-between">
                          <span title={a.operation_status || ''}>{a.operation_status || '—'}</span>
                          <span className="text-gray-400" title={a.time_updated || a.time_created || ''}>
                            {a.time_updated || a.time_created || '—'}
                          </span>
                        </div>
                      </button>
                    ))}
                  </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </Card>

      {active && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/30" onClick={closeDetail} />
          <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-3xl mx-4">
            <div className="px-5 py-4 border-b flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-lg font-semibold text-gray-900">
                  {active.name || 'Audience'}
                </span>
                <span className="px-2 py-0.5 rounded-full text-[10px] bg-indigo-50 text-indigo-700 border border-indigo-200">
                  {(active.subtype || '') || '—'}
                </span>
              </div>
              <button onClick={closeDetail} className="px-2 py-1 text-sm text-gray-600 hover:text-gray-900">Close</button>
            </div>
            <div className="p-5 space-y-3 max-h-[70vh] overflow-y-auto">
              {detailLoading ? (
                <div className="text-sm text-gray-500">Loading details…</div>
              ) : detailError ? (
                <div className="text-sm text-red-600">{detailError}</div>
              ) : detail ? (
                <>
                  <div className="flex items-center justify-end">
                    <label className="inline-flex items-center gap-2 text-xs text-gray-600 cursor-pointer">
                      <input type="checkbox" className="rounded border-gray-300" checked={showRaw} onChange={(e) => setShowRaw(e.target.checked)} />
                      Show raw JSON
                    </label>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <div className="text-xs text-gray-500">ID</div>
                      <div className="text-sm text-gray-800 break-all">{detail.id}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">Approx. Count</div>
                      <div className="text-sm text-gray-800">{detail.approximate_count != null ? detail.approximate_count.toLocaleString() : '—'}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">Delivery Status</div>
                      <div className="text-sm text-gray-800">{detail.delivery_status || '—'}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">Operation Status</div>
                      <div className="text-sm text-gray-800">{detail.operation_status || '—'}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">Created</div>
                      <div className="text-sm text-gray-800">{detail.time_created || '—'}</div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500">Updated</div>
                      <div className="text-sm text-gray-800">{detail.time_updated || '—'}</div>
                    </div>
                  </div>
                  {/* Targeting summary for SAVED audiences */}
                  {detail.kind === 'SAVED' && detail.targeting_summary && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Interests (include)</div>
                        <div className="flex flex-wrap gap-1">
                          {(detail.targeting_summary.include?.interests || []).slice(0, 50).map((n, i) => (
                            <span key={`i-${i}`} className="px-2 py-0.5 rounded-full text-[11px] bg-purple-50 text-purple-700 border border-purple-200">{n}</span>
                          ))}
                          {(detail.targeting_summary.include?.interests || []).length === 0 && (
                            <span className="text-xs text-gray-500">—</span>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Behaviors (include)</div>
                        <div className="flex flex-wrap gap-1">
                          {(detail.targeting_summary.include?.behaviors || []).slice(0, 50).map((n, i) => (
                            <span key={`b-${i}`} className="px-2 py-0.5 rounded-full text-[11px] bg-blue-50 text-blue-700 border border-blue-200">{n}</span>
                          ))}
                          {(detail.targeting_summary.include?.behaviors || []).length === 0 && (
                            <span className="text-xs text-gray-500">—</span>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Industries</div>
                        <div className="flex flex-wrap gap-1">
                          {(detail.targeting_summary.include?.industries || []).slice(0, 50).map((n, i) => (
                            <span key={`ind-${i}`} className="px-2 py-0.5 rounded-full text-[11px] bg-amber-50 text-amber-700 border border-amber-200">{n}</span>
                          ))}
                          {(detail.targeting_summary.include?.industries || []).length === 0 && (
                            <span className="text-xs text-gray-500">—</span>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Life Events</div>
                        <div className="flex flex-wrap gap-1">
                          {(detail.targeting_summary.include?.life_events || []).slice(0, 50).map((n, i) => (
                            <span key={`le-${i}`} className="px-2 py-0.5 rounded-full text-[11px] bg-fuchsia-50 text-fuchsia-700 border border-fuchsia-200">{n}</span>
                          ))}
                          {(detail.targeting_summary.include?.life_events || []).length === 0 && (
                            <span className="text-xs text-gray-500">—</span>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Interests (exclude)</div>
                        <div className="flex flex-wrap gap-1">
                          {(detail.targeting_summary.exclude?.interests || []).slice(0, 50).map((n, i) => (
                            <span key={`ei-${i}`} className="px-2 py-0.5 rounded-full text-[11px] bg-rose-50 text-rose-700 border border-rose-200">{n}</span>
                          ))}
                          {(detail.targeting_summary.exclude?.interests || []).length === 0 && (
                            <span className="text-xs text-gray-500">—</span>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Behaviors (exclude)</div>
                        <div className="flex flex-wrap gap-1">
                          {(detail.targeting_summary.exclude?.behaviors || []).slice(0, 50).map((n, i) => (
                            <span key={`eb-${i}`} className="px-2 py-0.5 rounded-full text-[11px] bg-rose-50 text-rose-700 border border-rose-200">{n}</span>
                          ))}
                          {(detail.targeting_summary.exclude?.behaviors || []).length === 0 && (
                            <span className="text-xs text-gray-500">—</span>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Locations</div>
                        <div className="flex flex-wrap gap-1">
                          {[
                            ...(detail.targeting_summary.locations?.countries || []),
                            ...(detail.targeting_summary.locations?.countryGroups || []),
                            ...(detail.targeting_summary.locations?.cities || []),
                            ...(detail.targeting_summary.locations?.regions || [])
                          ].slice(0, 60).map((n, i) => (
                            <span key={`loc-${i}`} className="px-2 py-0.5 rounded-full text-[11px] bg-emerald-50 text-emerald-700 border border-emerald-200">{n}</span>
                          ))}
                          {((detail.targeting_summary.locations?.countries || []).length +
                            (detail.targeting_summary.locations?.countryGroups || []).length +
                            (detail.targeting_summary.locations?.cities || []).length +
                            (detail.targeting_summary.locations?.regions || []).length) === 0 && (
                            <span className="text-xs text-gray-500">—</span>
                          )}
                        </div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-700 mb-1">Demographics</div>
                        <div className="text-xs text-gray-800">
                          <div>Age: {detail.targeting_summary.demographics?.ageMin || '—'} - {detail.targeting_summary.demographics?.ageMax || '—'}</div>
                          <div>Genders: {(detail.targeting_summary.demographics?.genders || []).join(', ') || '—'}</div>
                          {detail.targeting_summary.demographics?.languages?.length > 0 && (
                            <div>Languages: {detail.targeting_summary.demographics.languages.join(', ')}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {detail.description && (
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Description</div>
                      <div className="text-sm text-gray-800">{detail.description}</div>
                    </div>
                  )}
                  {/* Saved Audiences: show targeting */}
                  {showRaw && detail.kind === 'SAVED' && detail.targeting && (
                    <div>
                      <div className="text-xs text-gray-500 mb-1">Targeting</div>
                      <pre className="text-xs bg-gray-50 border border-gray-200 rounded-lg p-3 overflow-x-auto">
{JSON.stringify(detail.targeting, null, 2)}
                      </pre>
                    </div>
                  )}
                  {/* Custom Audiences: show rule/lookalike/info when available */}
                  {showRaw && detail.kind === 'CUSTOM' && (detail.rule || detail.lookalike) && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {detail.rule && (
                        <div>
                          <div className="text-xs text-gray-500 mb-1">Rule</div>
                          <pre className="text-xs bg-gray-50 border border-gray-200 rounded-lg p-3 overflow-x-auto">
{JSON.stringify(detail.rule, null, 2)}
                          </pre>
                        </div>
                      )}
                      {detail.lookalike && (
                        <div>
                          <div className="text-xs text-gray-500 mb-1">Lookalike Spec</div>
                          <pre className="text-xs bg-gray-50 border border-gray-200 rounded-lg p-3 overflow-x-auto">
{JSON.stringify(detail.lookalike, null, 2)}
                          </pre>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <div className="text-sm text-gray-500">No details.</div>
              )}
            </div>
          </div>
        </div>
      )}

      {showCreate && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/30" onClick={() => setShowCreate(false)} />
          <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4">
            <div className="px-5 py-4 border-b flex items-center justify-between">
              <span className="text-lg font-semibold text-gray-900">Create Saved Audience</span>
              <button onClick={() => setShowCreate(false)} className="px-2 py-1 text-sm text-gray-600 hover:text-gray-900">Close</button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="block text-xs text-gray-600 mb-1">Name</label>
                <input
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                  value={caName}
                  onChange={(e) => setCaName(e.target.value)}
                  placeholder="e.g. Glowy_Interests_TR"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Interests (comma separated)</label>
                <input
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                  value={caInterests}
                  onChange={(e) => setCaInterests(e.target.value)}
                  placeholder="e.g. shoes, fashion, sportswear"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Countries (comma separated, default TR)</label>
                <input
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                  value={caCountries}
                  onChange={(e) => setCaCountries(e.target.value)}
                  placeholder="TR,US"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Access token (optional override)</label>
                <input
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
                  value={caToken}
                  onChange={(e) => setCaToken(e.target.value)}
                  placeholder="Paste System User token with ads_management"
                />
                <p className="mt-1 text-[11px] text-gray-500">If provided, this token will be used to create the audience.</p>
              </div>
              {createError && <div className="text-sm text-red-600">{createError}</div>}
              {createResult && (
                <div className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2">
                  Created: {createResult?.id || 'OK'}
                </div>
              )}
              <div className="flex items-center justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setShowCreate(false)}
                  className="px-3 py-2 rounded-md text-sm border border-gray-300 text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  disabled={creating}
                  onClick={createSavedAudience}
                  className="px-3 py-2 rounded-md text-sm bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50"
                >
                  {creating ? 'Creating…' : 'Create'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


